export class AssignSupervisorRequestModel {
    SessionIds: number[];
    SupervisorUserId: number;

    constructor() {
        this.SessionIds = [];
        this.SupervisorUserId = 0;
    }
}